import cn from 'classnames'

import useViewport from 'libs/use-viewport'
import CopiedMessage from 'components/ui/copied-message'
import Image from 'next/image'
import copyIcon from 'components/ui/loan-id-box/copy-icon.svg'

import styles from './styles.module.scss'

interface ICellHeading {
  hiddenCopyButton?: boolean
  isCopied?: boolean
  onClick?: () => void
  className?: string
  messageClassName?: string
}

const CopyButton = ({ hiddenCopyButton = false, isCopied, className, onClick, messageClassName }: ICellHeading) => {
  const [viewport] = useViewport()

  const isDesktop = viewport === 'desktop'

  const width = isDesktop ? 14 : 10
  const height = isDesktop ? 19 : 12

  return isCopied ? (
    <CopiedMessage className={cn(styles.headingCopyMessage, className, messageClassName)} />
  ) : (
    !hiddenCopyButton && (
      <div className={cn(styles.headingIconWrapper, className)} onClick={onClick}>
        <Image src={copyIcon} alt="copy icon" layout="fixed" width={width} height={height} />
      </div>
    )
  )
}

export default CopyButton
